import { useEffect } from "react";
import { initPropertyPageTracking } from "@/lib/analytics";
import ReviewsSection from "@/pages/home/ReviewsSection";
import GuaranteedRentHero from "@/pages/guaranteed-rent/GuaranteedRentHero";
import GuaranteedRentComparison from "@/pages/guaranteed-rent/GuaranteedRentComparison";
import GuaranteedRentHowItWorks from "@/pages/guaranteed-rent/GuaranteedRentHowItWorks";
import GuaranteedRentBenefits from "@/pages/guaranteed-rent/GuaranteedRentBenefits";
import GuaranteedRentFAQ from "@/pages/guaranteed-rent/GuaranteedRentFAQ";
import GuaranteedRentLocations from "@/pages/guaranteed-rent/GuaranteedRentLocations";
import { GENERIC_GR } from "@/pages/guaranteed-rent/cityConfig";

export default function GuaranteedRentHub() {
  const path = "/guaranteed-rent/";

  useEffect(() => {
    const cleanup = initPropertyPageTracking(path);

    document.title = "Guaranteed Rent | Fixed Monthly Income | Truestays";

    const setMeta = (nameAttr, content) => {
      let el = document.querySelector(`meta[name="${nameAttr}"]`);
      if (!el) { el = document.createElement("meta"); el.name = nameAttr; document.head.appendChild(el); }
      el.setAttribute("content", content);
    };
    const setOgMeta = (property, content) => {
      let el = document.querySelector(`meta[property="${property}"]`);
      if (!el) { el = document.createElement("meta"); el.setAttribute("property", property); document.head.appendChild(el); }
      el.setAttribute("content", content);
    };

    setMeta("description", "Guaranteed rent from £1,100–£5,500/month. Fixed monthly income, zero voids, no hassle. Full property management included. Available across the UK & Dubai. Free valuation.");
    setMeta("robots", "index, follow");
    setMeta("keywords", "guaranteed rent, fixed rent, rent to rent, guaranteed rental income, property management, rental income, landlord services, rent guarantee");
    setOgMeta("og:type", "website");
    setOgMeta("og:title", "Guaranteed Rent | Fixed Monthly Income | Truestays");
    setOgMeta("og:description", "Earn £1,100–£5,500/month guaranteed. Fixed income, zero voids, full property management included. Available across the UK & Dubai. Get your free valuation.");
    setOgMeta("og:url", window.location.origin + path);

    let canonical = document.querySelector('link[rel="canonical"]');
    if (!canonical) { canonical = document.createElement("link"); canonical.rel = "canonical"; document.head.appendChild(canonical); }
    canonical.href = `https://truestays.co.uk${path}`;

    const scriptId = "ts-schema-gr-hub";
    let existing = document.getElementById(scriptId);
    if (existing) existing.remove();
    const script = document.createElement("script");
    script.id = scriptId;
    script.type = "application/ld+json";
    script.text = JSON.stringify({
      "@context": "https://schema.org",
      "@graph": [
        { "@type": "LocalBusiness", "@id": `https://truestays.co.uk${path}`, "name": "Truestays — Guaranteed Rent", "description": "Fixed monthly rental income with full property management included. No voids, no hassle. Available across the UK & Dubai.", "url": `https://truestays.co.uk${path}`, "priceRange": "From £1,100–£5,500/month", "aggregateRating": { "@type": "AggregateRating", "ratingValue": "5.0", "reviewCount": "96", "bestRating": "5" } },
        { "@type": "BreadcrumbList", "itemListElement": [{ "@type": "ListItem", "position": 1, "name": "Home", "item": "https://truestays.co.uk/" }, { "@type": "ListItem", "position": 2, "name": "Guaranteed Rent", "item": `https://truestays.co.uk${path}` }] }
      ]
    });
    document.head.appendChild(script);

    return () => {
      const s = document.getElementById(scriptId);
      if (s) s.remove();
      cleanup();
    };
  }, [path]);

  return (
    <>
      <GuaranteedRentHero city={GENERIC_GR} />
      <GuaranteedRentComparison city={GENERIC_GR} />
      <GuaranteedRentBenefits />
      <GuaranteedRentHowItWorks />
      <ReviewsSection />
      <GuaranteedRentFAQ city={GENERIC_GR} />
      <GuaranteedRentLocations />
    </>
  );
}